export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_soul-redesign/artifacts/g63jz3ly_LOGO.jpeg";

export const CALENDLY_URL =
  "https://calendar.app.google/wNiQ6Y4kd6o7DFxk7";

export const CONTACT_EMAIL = "sade@thealignedsoulutions.com";
export const INSTAGRAM_HANDLE = "thealignedsoulutions";
export const INSTAGRAM_URL = "https://instagram.com/thealignedsoulutions";

export const IMAGES = {
  heroCollaboration:
    "https://static.prod-images.emergentagent.com/jobs/2f096136-ca5a-4211-ba2f-25f2c07485df/images/c9c8ddd6ecb56bbf242189cfc4c99ac750a9014aec79234484b79d5d35959ad6.png",
  founderSade:
    "https://customer-assets.emergentagent.com/job_soul-redesign/artifacts/j7nloo9r_HEADSHOT.JPG",
  abstractTexture:
    "https://static.prod-images.emergentagent.com/jobs/2f096136-ca5a-4211-ba2f-25f2c07485df/images/fbc003495bc81b1f2d41855612e77fc6926810797cb0b2a60d153220352b58eb.png",
  diverseMeeting:
    "https://images.unsplash.com/photo-1573497701240-345a300b8d36?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  handsSeedling:
    "https://images.unsplash.com/photo-1518398046578-8cca57782e17?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  communityCircle:
    "https://images.unsplash.com/photo-1529070538774-1843cb3265df?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
};

export const NAV_LINKS = [
  { id: "services", label: "Services" },
  { id: "about", label: "About" },
  { id: "approach", label: "Approach" },
  { id: "testimonials", label: "Voices" },
  { id: "contact", label: "Contact" },
];
